import { useState, useEffect, useRef } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import { FaBoxOpen } from 'react-icons/fa'
import PageCreateHeader from '../../components/PageCreateHeader'

// path /v1/drug/pack/update/:id
export default function UpdatePaket() {

  const [items, setItems] = useState([
    { obat: '', quantity: '', search: '', open: false }
  ])
  const [paketId, setPaketId] = useState(null)
  const { name, outlet } = useParams()
  const navigate = useNavigate()
  const [role, setRole] = useState("")
  const [outlets, setOutlets] = useState([])
  const [drugs, setDrugs] = useState([])
  const [meta, setMeta] = useState({})
  const [selectedOutlet, setSelectedOutlet] = useState("")

  const [form, setForm] = useState({
    name: "",
    hargaJual: "",
    tuslah: "",
    embalase: ""
  })

  const token = localStorage.getItem("token")
  const dropdownRefs = useRef([]) // Ref untuk dropdown

  // ===============================
  // INIT ROLE
  // ===============================
  useEffect(() => {
    const userRole = localStorage.getItem("role")
    setRole(userRole)

    if (userRole === "manager") {
      const outletId = localStorage.getItem("id_outlet")
      if (outletId) {
        setSelectedOutlet(String(outletId))
      }
    }

    if (userRole === "owner") {
      fetchOutlets()
    }
  }, [])

  // Tambahkan useEffect baru untuk set selectedOutlet berdasarkan nama outlet di URL setelah outlets loaded
  useEffect(() => {
    if (role === "owner" && outlets.length > 0 && name && outlet) {
      const found = outlets.find(o => o.name === outlet)
      if (found) {
        setSelectedOutlet(String(found.id))
      }
    }
  }, [role, outlets, name, outlet])

  useEffect(() => {
    if (name && outlet) {
      fetchDetail()
    }
  }, [name, outlet, role])

  // Hapus useEffect untuk handleClickOutside global, ganti dengan onBlur atau ref
  useEffect(() => {
    if (!selectedOutlet || selectedOutlet === "undefined") return
    fetchDrugs(selectedOutlet)
  }, [selectedOutlet])

  // ===============================
  // FETCH OUTLET
  // ===============================
  const fetchOutlets = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      const data = await response.json()
      if (data.success) setOutlets(data.data)
    } catch (error) {
      console.error("Error fetching outlets:", error)
    }
  }

  const fetchDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/drug/pack/${name}-${outlet}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      const data = await response.json()

      if (data.success) {
        const paket = data.data

        setPaketId(paket.id)

        setForm({
          name: paket.name || "",
          hargaJual: paket.harga_jual || "",
          tuslah: paket.tuslah || "",
          embalase: paket.embalase || ""
        })

        setSelectedOutlet(String(paket.outlet_id))

        const mappedItems = paket.items.map(i => ({
          obat: String(i.id),
          quantity: i.qty,
          search: i.name || "",
          open: false
        }))

        setItems(mappedItems.length > 0 ? mappedItems : [{ obat: '', quantity: '', search: '', open: false }])
      }
    } catch (error) {
      console.error(error)
    }
  }

  // ===============================
  // FETCH DRUG
  // ===============================
  const fetchDrugs = async (outletId, searchQuery = "") => {
    if (!outletId || outletId === "undefined") return

    try {
      const url = new URL(`${process.env.REACT_APP_API_BASE_URL}/v1/drug`)
      url.searchParams.append("id_outlet", outletId)

      if (searchQuery) {
        url.searchParams.append("search", searchQuery)
      }

      const response = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      })

      const data = await response.json()

      if (data.success) {
        setDrugs(data.data)
        setMeta(data.meta)
      }
    } catch (error) {
      console.error("Error fetching drugs:", error)
    }
  }

  // ===============================
  // FORM
  // ===============================
  const handleFormChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    })
  }

  const handleOutletChange = (e) => {
    const outletId = e.target.value
    setSelectedOutlet(outletId)
    fetchDrugs(outletId)
  }

  // ===============================
  // ITEMS
  // ===============================
  const handleAddItem = () => {
    setItems(prev => [
      ...prev,
      { obat: '', quantity: '', search: '', open: false }
    ])
  }

  const handleRemoveItem = (index) => {
    setItems(prev => {
      if (prev.length === 1) return prev
      return prev.filter((_, i) => i !== index)
    })
  }

  const handleItemChange = (index, field, value) => {
    const updated = [...items]
    updated[index][field] = value
    setItems(updated)
  }

  // ===============================
  // SEARCH PER ROW
  // ===============================
  const handleSearch = (index, value) => {
    const updated = [...items]
    updated[index].search = value
    updated[index].open = true
    setItems(updated)

    if (!selectedOutlet) return

    fetchDrugs(selectedOutlet, value)
  }

  const handleSelectDrug = (index, drug) => {
    const updated = [...items]
    updated[index].obat = String(drug.id)
    updated[index].search = drug.name
    updated[index].open = false
    setItems(updated)
  }

  const handleBlur = (index) => {
    // Tutup dropdown saat blur
    setTimeout(() => {
      const updated = [...items]
      updated[index].open = false
      setItems(updated)
    }, 150) // Delay untuk allow click
  }

  // ===============================
  // VALIDATION
  // ===============================
  const validateForm = () => {
    if (!form.name.trim()) {
      alert("Nama paket wajib diisi")
      return false
    }
    if (!selectedOutlet) {
      alert("Outlet wajib dipilih")
      return false
    }
    if (!form.hargaJual || parseFloat(form.hargaJual) <= 0) {
      alert("Harga jual wajib diisi dan harus positif")
      return false
    }
    for (let item of items) {
      if (!item.obat || !item.quantity || parseInt(item.quantity) <= 0) {
        alert("Setiap item harus memiliki obat dan quantity yang valid")
        return false
      }
    }
    return true
  }

  // ===============================
  // SUBMIT
  // ===============================
  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) return

    try {
      const payload = {
        name: form.name,
        outlet_id: parseInt(selectedOutlet),
        harga_jual: parseFloat(form.hargaJual),
        tuslah: parseFloat(form.tuslah || 0),
        embalase: parseFloat(form.embalase || 0),
        items: items.map(i => ({
          drug_id: parseInt(i.obat),
          qty: parseInt(i.quantity)
        }))
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/v1/drug/pack/update/${paketId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      )

      const data = await response.json()

      if (data.success) {
        await Swal.fire({
          icon: "success",
          title: "Berhasil",
          text: "Update paket berhasil",
          timer: 1500,
          showConfirmButton: false,
          background: "#ffffff",
          color: "#0f172a"
        })
        navigate("/obat-paket/paket")
      } else {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: data.message || "Gagal update"
        })
      }
    } catch (error) {
      console.error(error)
      Swal.fire({
        icon: "error",
        title: "Terjadi error",
        text: "Silakan coba lagi"
      })
    }
  }

  return (
    <div className="min-h-screen flex flex-col space-y-6 bg-slate-50 p-6 w-full min-w-0">
      <PageCreateHeader
        icon={FaBoxOpen}
        title="Update Paket Obat"
        description="Perbarui komposisi dan harga paket"
        breadcrumbs={[
          { label: 'Enterprise', to: '/' },
          { label: 'Paket', to: '/obat-paket/paket' },
          { label: 'Update Paket' },
        ]}
      />

      <div className="bg-white p-8 rounded-3xl shadow-xl border border-slate-200 w-full min-w-0">
          <form className="space-y-6" onSubmit={handleSubmit}>
            
            {/* NAME */}
            <div>
              <label className="block text-sm font-medium text-slate-700">Name</label>
              <input
                name="name"
                value={form.name}
                onChange={handleFormChange}
                className="mt-2 block w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                placeholder="Nama Paket"
                required
              />
            </div>

            {/* OUTLET */}
            <div>
              <label className="block text-sm font-medium text-slate-700">Outlet</label>
              <select
                value={selectedOutlet}
                onChange={handleOutletChange}
                disabled={role === "manager"}
                className="mt-2 block w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                required
              >
                <option value="">Pilih Outlet</option>
                {outlets.map(o => (
                  <option key={o.id} value={String(o.id)}>{o.name}</option>
                ))}
              </select>
            </div>

            {/* HARGA */}
            <div>
              <label className="block text-sm font-medium text-slate-700">Harga Jual</label>
              <input
                type="number"
                name="hargaJual"
                value={form.hargaJual}
                onChange={handleFormChange}
                className="mt-2 block w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                placeholder="Harga Jual Paket"
                min="0"
                step="0.01"
                required
              />
            </div>

            {/* TUSLAH & EMBALASE */}
            <div className="grid grid-cols-1 gap-6">
              <div>
                <label className="block text-sm font-medium text-slate-700">Tuslah</label>
                <input
                  type="number"
                  name="tuslah"
                  value={form.tuslah}
                  onChange={handleFormChange}
                  className="mt-2 block w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                  placeholder="Tuslah"
                  min="0"
                  step="0.01"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700">Embalase</label>
                <input
                  type="number"
                  name="embalase"
                  value={form.embalase}
                  onChange={handleFormChange}
                  className="mt-2 block w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                  placeholder="Embalase"
                  min="0"
                  step="0.01"
                />
              </div>
            </div>

            {/* ITEMS */}
            <div>
              <div className="mb-4 flex items-center justify-between gap-3">
                <label className="block text-sm font-medium text-slate-700">Items</label>
                <button
                  type="button"
                  onClick={handleAddItem}
                  className="inline-flex items-center rounded-full border border-green-600 bg-green-100 px-4 py-3 text-sm font-medium text-green-700 transition hover:bg-green-200"
                >
                  Add Row
                </button>
              </div>

              <div className="overflow-visible rounded-3xl border border-slate-200 shadow-sm">
                <table className="min-w-full divide-y divide-slate-200">
                  <thead className="bg-slate-50">
                    <tr>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">Obat</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">Quantity</th>
                      <th className="px-6 py-4 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">Action</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-slate-200">
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td className="px-6 py-4 whitespace-nowrap relative">
                          <input
                            ref={el => dropdownRefs.current[index] = el}
                            value={item.search}
                            placeholder="Pilih Obat"
                            onChange={(e) => handleSearch(index, e.target.value)}
                            onBlur={() => handleBlur(index)}
                            className="block w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                          />

                          {item.open && (
                            <div className="absolute z-50 mt-2 w-full rounded-2xl border border-slate-200 bg-white shadow-lg max-h-48 overflow-auto">
                              {drugs.map(d => (
                                <div
                                  key={d.id}
                                  onClick={() => handleSelectDrug(index, d)}
                                  className={`px-4 py-3 cursor-pointer ${String(d.id) === String(item.obat) ? "bg-indigo-100 text-slate-900 font-semibold" : "text-slate-700 hover:bg-slate-100"}`}
                                >
                                  {d.name}
                                </div>
                              ))}
                            </div>
                          )}
                        </td>

                        <td className="px-6 py-4 whitespace-nowrap">
                          <input
                            type="number"
                            value={item.quantity}
                            onChange={(e) => handleItemChange(index, 'quantity', e.target.value)}
                            className="block w-full rounded-2xl border border-slate-300 bg-slate-50 px-4 py-3 text-sm text-slate-900 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-100"
                            placeholder="Quantity"
                            min="1"
                            required
                          />
                        </td>

                        <td className="px-6 py-4 whitespace-nowrap">
                          <button
                            type="button"
                            onClick={() => handleRemoveItem(index)}
                            disabled={items.length === 1}
                            className="inline-flex items-center gap-2 rounded-full border border-red-600 bg-red-50 px-4 py-3 text-sm font-medium text-red-700 hover:bg-red-100 disabled:opacity-50"
                          >
                            Hapus
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* SUBMIT */}
            <div className="pt-4 border-t border-slate-200">
              <button
                type="submit"
                className="inline-flex justify-center w-full rounded-2xl bg-yellow-600 px-6 py-4 text-base font-semibold text-white shadow-lg shadow-indigo-200/30 transition hover:bg-indigo-700"
              >
                Update Paket
              </button>
            </div>

          </form>
      </div>
    </div>
  )
}